Ext.define('SA.lq.edit.EditViewHeader', {
    alias: 'widget.lq-edit-view-header',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-header',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-edit-header-upper',

            items: [
                {
                    xtype: 'component',
                    itemId: 'titleCmp',
                    cls: 'sa-edit-header-text',
                    html: 'Edit Location Query'
                }, {
                    xtype: 'sa-button',
                    itemId: 'doneBtn',
                    cls: 'sa-edit-header-done-btn',
                    text: 'Done',
                    ui: 'primary'
                }
            ]
        }, {
            xtype: 'component',
            itemId: 'messageCmp',
            cls: 'sa-edit-header-warning',
            hidden: true,

            tpl: [
                '<svg class="sa-edit-header-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div>{message}</div>'
            ]
        }
    ],

    setDoneBtnClickHandler(handler) {
        this.doneBtn.on('click', handler);
    },

    setState(state) {
        this.titleCmp.update(`Edit ${Ext.String.htmlEncode(state.getViewName())}`);

        if (!state.isViewable()) {
            let message = (state.getSelectableLocations().length === 0)
                ? 'Please add a location to the project.'
                : 'Please select a location to view the report.';

            this.setUnviewable({message});
            return;
        }

        this.setViewable();
    },

    setUnviewable({message}) {
        this.doneBtn.disable();
        this.messageCmp.update({message});
        this.messageCmp.show();
    },

    setViewable() {
        this.doneBtn.enable();
        this.messageCmp.hide();
    }
});